class AccordionDef {
  constructor(el) {
    this.el = el
    this.summary = el.querySelector('summary')
    this.content = el.querySelector('.accordion__content')
    this.padding = 28

    AccordionEventManager.subscribe(this)

    this.animation = null
    this.isClosing = false
    this.isExpanding = false
    this.summary.addEventListener('click', (e) => this.onClick(e))
  }

  onClick(e) {
    e.preventDefault()

    this.el.style.overflow = 'hidden'

    if (this.isClosing || !this.el.open) {
      this.open()
    } else if (this.isExpanding || this.el.open) {
      this.shrink()
    }
  }

  shrink() {
    this.el.style.overflow = 'hidden'

    setTimeout(() => {
      this.el.classList.remove('active')
      this.el.classList.add('close')
    }, 400)

    this.isClosing = true

    const startHeight = `${this.el.offsetHeight + this.padding}px`
    const endHeight = `${this.summary.offsetHeight + this.padding}px`

    if (this.animation) {
      this.animation.cancel()
    }

    this.animation = this.el.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 400,
        easing: 'ease-out',
      }
    )

    this.animation.onfinish = () => this.onAnimationFinish(false)
    this.animation.oncancel = () => (this.isClosing = false)
  }

  open() {
    AccordionEventManager.publish(this)
    this.el.classList.remove('close')
    this.el.classList.add('active')

    this.el.style.height = `${this.el.offsetHeight}px`
    this.el.open = true
    window.requestAnimationFrame(() => {this.expand()})
  }

  expand() {
    this.isExpanding = true
    const startHeight = `${this.summary.offsetHeight}px`
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`

    if (this.animation) {
      this.animation.cancel()
    }

    this.animation = this.el.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 400,
        easing: 'ease-out',
      }
    )

    this.animation.onfinish = () => this.onAnimationFinish(true)
    this.animation.oncancel = () => (this.isExpanding = false)
  }

  onAnimationFinish(open) {
    this.el.open = open
    this.animation = null
    this.isClosing = false
    this.isExpanding = false
    this.el.style.height = this.el.style.overflow = ''
  }
}

const AccordionEventManager = {
  subscribers: [],

  subscribe(accordionInstance) {
    this.subscribers.push(accordionInstance)
  },

  publish(openingAccordion) {
    this.subscribers.forEach((subscriber) => {
      if (subscriber !== openingAccordion && subscriber.el.open) {
        subscriber.shrink()
      }
    })
  }
}

export { AccordionDef }
